import { useState, useEffect, useCallback } from 'react'

import { Tooltip } from 'antd'
import { useSelector } from 'react-redux'
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { selectUser } from '../../../reducers/UserReducer'
import NissForm from './NissForm'
import OptInForm from './OptInForm'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import isObject from 'lodash/isObject'
import { getAssistantOptin, updateAssistant } from '../../../utils/api/assistant'
import { onError, onSuccess } from '../../../utils/apiHelper'
import { DATA_SHARING_TYPE, Optin } from '../../../utils/entities/optin'
import { createUserOptin, updateUserOptin } from '../../../utils/api/user'

import '../../../assets/profile-page.scss'

const PRIVATE_DATA_TITLE = 'My personal contact information'
const TIPS_TEXT = 'Information necessary for the preparation of your internship and contact in case of problems.\n' +
  'Possibility of contact for recruitment purposes if desired.'

const PersonalInformationsForm = ({ assistant, form, onChange }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [dataUsageOptIn, setDataUsageOptIn] = useState(false)

  const fetchOptins = useCallback(() => {
    getAssistantOptin(user, user.assistant, { type: DATA_SHARING_TYPE }).then(({ data }) => {
      setDataUsageOptIn(data[0] ?? null)
    })
  }, [user.id])

  useEffect(() => {
    if (isObject(user)) {
      fetchOptins()
    }
  }, [user?.id, fetchOptins])

  const onSwitchChange = value => {
    const newOptin = dataUsageOptIn === null
      ? new Optin({ accepted: true, text: t('data_sharing_optin_text') })
      : new Optin({ ...dataUsageOptIn, accepted: !dataUsageOptIn.accepted })

    if (dataUsageOptIn === null) {
      createUserOptin(newOptin, user).then(json => {
        if (json?.data) {
          onSuccess(t('The optin has been successfully created'))
        } else {
          onError(t('An error occured during the optin creation'))
        }

        fetchOptins()
      })
    } else {
      updateUserOptin(newOptin, user).then(json => {
        if (json?.data) {
          onSuccess(t('The optin has been successfully updated'))
        } else {
          onError(t('An error occured during the optin update'))
        }

        fetchOptins()
      })
    }
  }

  const handleNissUpdate = niss => {
    updateAssistant(assistant, { niss: niss, email: assistant.email }, user).then(() => {
      onSuccess(t('student_profile.update_niss.success'))
      onChange({ ...assistant, niss: niss })
    })
  }

  return (
    <>
      <h2 style={{ margin: '35px 5px 15px' }}>
        {[t(PRIVATE_DATA_TITLE), ' ',
          <Tooltip key='personal_section_tooltip' placement='right' title={t(TIPS_TEXT)}>
            <FontAwesomeIcon icon={faQuestionCircle} color='#1890ff' />
          </Tooltip>
        ]}
      </h2>

      <OptInForm
        optInValue={dataUsageOptIn.accepted}
        onChange={onSwitchChange}
        marginBottom='10px'
      />
      <NissForm niss={assistant.niss} onSubmit={handleNissUpdate} />
    </>
  )
}

export default PersonalInformationsForm
